import React, { useState, useEffect } from 'react';
import './App.css';
import theme from './theme';
import GridBackground from './GridBackground';
import { Analytics } from "@vercel/analytics/react";
// Import the JSON data
import projectsData from './data/aimeelinks.json';
import avatarImage from './assets/photo.webp';

// Nuevos imports (componentes extraídos)
import CardProfileComponent from './components/cardprofilecomponent';

function App() {
	// Datos desde el JSON
	const profile = { ...(projectsData.profile || {}), avatar: avatarImage };
	const contact = projectsData.contact || {};
	const labels = projectsData.labels || {};
	const socials = Array.isArray(projectsData.socials) ? projectsData.socials : [];
	const projects = Array.isArray(projectsData.projects) ? projectsData.projects : [];
	const cv = projectsData.cv || {};

	// Nuevo: detector responsive del ancho de la ventana
	const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
	useEffect(() => {
		function onResize() {
			setWidth(window.innerWidth);
		}
		window.addEventListener('resize', onResize);
		return () => window.removeEventListener('resize', onResize);
	}, []);

	// puntos de quiebre:
	
	const isSmall = width < 420;
	const isMedium = width >= 420 && width < 768;

	// Valores responsivos
	const avatarSize = isSmall ? 100 : isMedium ? 127 : 127;
	const nameFontSize = isSmall ? 20 : isMedium ? 24 : 28;
	const subtitleFontSize = isSmall ? 12 : 13;
	const projectsTitleSize = isSmall ? 12 : 13;
	const linkFontSize = isSmall ? 14 : 16;
	const linkPadding = isSmall ? '10px 12px' : '14px 18px';
	const linkRadius = isSmall ? 22 : 28;
	const socialIconSize = isSmall ? 16 : 18;
	const socialGap = isSmall ? 8 : 16;

	return (
		// fusionamos theme.page con overrides para asegurar comportamiento correcto
		<div style={{ ...theme.page, position: 'relative', minHeight: '100vh', overflowX: 'hidden' }}>
			{/* fondo de cuadricula: fijo y detrás de todo */}
			<GridBackground gridSize={48} lineColor="rgba(59, 131, 246, 0.27)" />

			{/* Analíticas y contenido por encima del fondo */}
			<Analytics/>

			{/* Se delega la tarjeta al nuevo componente */}
			<CardProfileComponent
				profile={profile}
				contact={contact}
				labels={labels}
				socials={socials}
				projects={projects}
				cv={cv}
				avatarSize={avatarSize}
				nameFontSize={nameFontSize}
				subtitleFontSize={subtitleFontSize}
				projectsTitleSize={projectsTitleSize}
				linkFontSize={linkFontSize}
				linkPadding={linkPadding}
				linkRadius={linkRadius}
				socialIconSize={socialIconSize}
				socialGap={socialGap}
			/>
		</div>
	);
}

export default App;
